import { useEffect } from "react";
import { KeyValue } from "@/main/models/common";
import { useForm } from "react-hook-form";
import * as S from "./styles";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import { getTranslateByKey } from "@/main/services/utils";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";

interface ICompaniesWillSeeFilters {
	optionsCompanyType: KeyValue[];
	resetTrigger: number;
	onSearch: (data: ICompaniesWillSeeFormSearch) => void;
	onClear: () => void;
	isLoading: boolean;
}

const INITIAL_FORM_STATE = {
	companyName: "",
	rfc: "",
	companyType: null as KeyValue | null,
};

export type ICompaniesWillSeeFormSearch = typeof INITIAL_FORM_STATE;

export function CompaniesWillSeeFilters({
	optionsCompanyType,
	resetTrigger,
	onSearch,
	onClear,
	isLoading,
}: ICompaniesWillSeeFilters) {
	const { control, handleSubmit, reset, setValue } = useForm<ICompaniesWillSeeFormSearch>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE,
	});

	function onClearFilters() {
		onClear();
		reset(INITIAL_FORM_STATE);
	}

	useEffect(() => {
		reset(INITIAL_FORM_STATE);
	}, [resetTrigger]);

	return (
		<form onSubmit={handleSubmit(onSearch)}>
			<S.ContainerFilters>
				<KogInputTextControlledNew
					control={control}
					name="companyName"
					id="id-companiesWillSee-name-input"
					inputProps={{ maxLength: 250 }}
					label={getTranslateByKey("information.companyName")}
				/>

				<KogInputTextControlledNew
					control={control}
					name="rfc"
					id="id-companiesWillSee-rfc-input"
					inputProps={{ maxLength: 12 }}
					label={getTranslateByKey("information.rfc")}
				/>

				<KogAutoCompleteControlled
					id={"id-compoaniesWillSee-select-companyType"}
					label={getTranslateByKey("information.companyType")}
					control={control}
					nameCustom="companyType"
					errorMessageCustom=""
					hasErrorCustom={false}
					options={optionsCompanyType}
					onChangeCustom={() => {}}
					disabled={false}
					setValueCustom={setValue}
				/>

				<S.AreaButtons>
					<SecondaryButton id="id-SupervisionAssingnment-btn-clear" disabled={isLoading} onClick={onClearFilters}>
						{getTranslateByKey("information.clear")}
					</SecondaryButton>

					<SecondaryButton id="id-SupervisionAssingnment-button-search" isLoading={isLoading} type="submit">
						{getTranslateByKey("information.search")}
					</SecondaryButton>
				</S.AreaButtons>
			</S.ContainerFilters>
		</form>
	);
}
